module.exports = __webpack_public_path__ + "static/Auto-Share-1-e1407758983145-daf93a142ad9d088f29246727a3494f0.jpg";